module.exports = __webpack_public_path__ + "img/fixed_sink.9988b672.svg";